// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import size from 'lodash/size'
import { connect } from 'react-redux'
import { getCollection } from '@fakundo/redux-entities'

// Constants
import { PROPOSALS } from 'constants/entityNames'

// Atoms
import { ScrollSection } from 'atoms/ScrollSections'
import { AppSavingIndicator } from 'atoms/AppSaving'

// Components
import ProposalCreationButtons from 'components/Proposals/CreationButtons'
import ProposalList from 'components/Proposals/List'
import ProposalEditor from 'components/Proposals/Editor'
import ProposalUnsplash from 'components/Proposals/Unsplash'
import { updateWidgetOptions, openWidgetOnce } from 'components/Widget/Preview'
import StepContainer from './StepContainer'
import StepTitle from './StepTitle'
import StepSpacer from './StepSpacer'
import StepButton from './StepButton'
import StepParagraph from './StepParagraph'

const mapStateToProps = state => ({
  proposalsCount: size(getCollection(state, PROPOSALS))
})

export default
@connect(mapStateToProps)
class OnboardingCustomizationStep extends Component {
  static propTypes = {
    meGetter: PropTypes.object.isRequired,
    proposalsCount: PropTypes.number,
  }

  state = {
    proposalUuid: null,
    unsplash: false,
  }

  completeStep = sectionProps => () => {
    const { onSectionActivate, sectionIndex } = sectionProps
    onSectionActivate(sectionIndex + 1)
  }

  isProposalSelected = (proposal) => {
    const { proposalUuid } = this.state
    return proposal.uuid === proposalUuid
  }

  openWidgetPreview = (proposal) => {
    updateWidgetOptions({ proposalId: proposal.id })
    openWidgetOnce()
  }

  handleProposalCreate = (proposal) => {
    this.setState({ proposalUuid: proposal.uuid })
    this.openWidgetPreview(proposal)
  }

  handleProposalDelete = (proposal) => {
    if (this.isProposalSelected(proposal)) {
      this.setState({ proposalUuid: null })
    }
  }

  handleProposalSelect = (proposal) => {
    const selected = this.isProposalSelected(proposal)
    this.setState({ proposalUuid: selected ? null : proposal.uuid })
    if (!selected) this.openWidgetPreview(proposal)
  }

  handleProposalUnsplashSelect = (proposal) => {
    this.setState({ unsplash: true, proposalUuid: proposal.uuid })
  }

  handleUnsplashClose = sectionProps => () => {
    const { onSectionActivate, sectionIndex } = sectionProps
    this.setState({ unsplash: false, proposalUuid: null }, () => {
      onSectionActivate(sectionIndex)
    })
  }

  renderContent = (sectionProps) => {
    const { meGetter, proposalsCount } = this.props
    const { disabled } = sectionProps
    const { proposalUuid, unsplash } = this.state

    return (
      <StepContainer>
        <StepTitle>Customize your widget</StepTitle>
        <StepSpacer small />
        <StepParagraph>Pick a template or build the flow from scratch</StepParagraph>
        <StepSpacer small />
        { meGetter.isSucceded && !disabled && (
          <Fragment>
            <ProposalCreationButtons
              activateProposals
              onCreate={this.handleProposalCreate}
            />
            <ProposalList
              selectedProposalUuid={proposalUuid}
              onProposalDelete={this.handleProposalDelete}
              onProposalSelect={this.handleProposalSelect}
              onProposalUnsplashSelect={this.handleProposalUnsplashSelect}
            />
            { proposalUuid && (
              <Fragment>
                <StepSpacer small />
                { unsplash
                  ? (
                    <ProposalUnsplash
                      proposalUuid={proposalUuid}
                      onClose={this.handleUnsplashClose(sectionProps)}
                    />
                  )
                  : (
                    <ProposalEditor proposalUuid={proposalUuid} />
                  )
                }
              </Fragment>
            ) }
            <AppSavingIndicator />
          </Fragment>
        ) }
        <StepSpacer small />
        <StepButton disabled={disabled} onClick={this.completeStep(sectionProps)}>
          { proposalsCount ? 'next' : 'skip' }
        </StepButton>
      </StepContainer>
    )
  }

  render() {
    return (
      <ScrollSection {...this.props}>
        { this.renderContent }
      </ScrollSection>
    )
  }
}
